import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DepartmentType } from './departments';

type Role = {
  id: number;
  name: string;
};
export type UserType = {
  id?: number;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  phone: string;
  department: DepartmentType;
  privacyStatus: boolean;
  isActive: boolean;
  avatar: string;
  roles: Role[];
  room: any;
};

export type AuthenticatedType = {
  /** アクセストークン有効期限（Unix ms）。httpOnly Cookie の JWT と同期 */
  accessTokenExpiresAt: number | null;
  userId: number | null;
  user: UserType | null;
  privacyStatus: boolean;
  inRoom: boolean;
};

const initialState: AuthenticatedType = {
  accessTokenExpiresAt: null,
  userId: null,
  user: null,
  privacyStatus: false,
  inRoom: false,
};

export interface LoggedInPayloadActionInterface {
  accessTokenExpiresAt: number;
  userId: number | null;
  user: UserType;
  privacyStatus: boolean;
}

const slice = createSlice({
  name: 'authenticated',
  initialState,
  reducers: {
    loggedIn: (state, action: PayloadAction<LoggedInPayloadActionInterface>) => {
      return {
        ...state,
        accessTokenExpiresAt: action.payload.accessTokenExpiresAt,
        userId: action.payload.userId,
        user: action.payload.user,
        privacyStatus: action.payload.user?.privacyStatus as boolean,
      };
    },
    sessionRefreshed: (state, action: PayloadAction<{ accessTokenExpiresAt: number }>) => {
      return {
        ...state,
        accessTokenExpiresAt: action.payload.accessTokenExpiresAt,
      };
    },
    loggedOut: (state) => {
      return {
        ...state,
        accessTokenExpiresAt: null,
        userId: null,
        user: null,
        privacyStatus: false,
        inRoom: false,
      };
    },
    privacyStatusOn: (state) => {
      return { ...state, privacyStatus: true };
    },
    privacyStatusOff: (state) => {
      return { ...state, privacyStatus: false };
    },
    privacyStatusToggle: (state) => {
      return { ...state, privacyStatus: !state.privacyStatus };
    },
    updateUser: (state, action: PayloadAction<UserType>) => {
      const inRoom = !!action.payload.room;
      return { ...state, user: action.payload, inRoom };
    },
  },
});

export default slice.reducer;

export const {
  loggedIn,
  loggedOut,
  sessionRefreshed,
  privacyStatusOn,
  privacyStatusOff,
  privacyStatusToggle,
  updateUser,
} = slice.actions;
